import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './definitions-config';

function VerificationTable({ rowData, setVerifyProfile }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='flex items-center h-full'>
        <button
          onClick={() => setVerifyProfile(params.data)}
          className='inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-md cursor-pointer transition-all duration-150'
          style={{
            backgroundColor: 'var(--primary-main)',
            color: 'var(--primary-contrast)',
            border: 'none',
          }}
        >
          Review
          <svg
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M5 12h14M12 5l7 7-7 7' />
          </svg>
        </button>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };

  return (
    <div className='ag-theme-alpine' style={{ height: 'calc(100vh - 180px)', width: '100%' }}>
      <AgGridReact
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        frameworkComponents={frameworkComponents}
      />
    </div>
  );
}

export default VerificationTable;
